import { useCallback, useEffect, useState } from "react";

/**
 * Tiny fetch-on-mount hook with `reload` returned. Centralises the pattern
 * used by Workers/Tools/Exposures/CheckIns/Dashboard pages.
 */
export default function useFetch(fetcher) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const result = await fetcher();
      setData(result);
      setError(null);
    } catch (err) {
      console.error("Fetch failed:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [fetcher]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}
